import 'pages/settings/seo-vars/seo-vars-word-exclude-modal.tag'
riot.tag2('seo-vars-word-exclude', '  <catalog object="WordExclude" cols="{cols}" reload="true" add="{permission(addEdit, &quot;settings&quot;, &quot;0100&quot;)}" remove="{permission(remove, &quot;settings&quot;, &quot;0001&quot;)}" dblclick="{permission(addEdit, &quot;settings&quot;, &quot;1010&quot;)}">\n    <yield to="body">\n      <datatable-cell name="id">{row.id}</datatable-cell>\n      <datatable-cell name="value">{row.value}</datatable-cell>\n    </yield>\n  </catalog>\n', '', '', function(opts) {
'use strict';

var self = this;

self.mixin('permissions');
self.mixin('remove');

self.collection = 'WordExclude';

self.cols = [{ name: 'id', value: '#' }, { name: 'value', value: 'Значение' }];

self.addEdit = function (e) {
    var id;
    if (e.item && e.item.row) {
        id = e.item.row.id;
    }

    modals.create('seo-vars-word-exclude-modal', {
        type: 'modal-primary',
        id: id,
        submit: function submit() {
            var _this = this;
            var params = _this.item;

            _this.error = _this.validation.validate(_this.item, _this.rules);

            if (!_this.error) {
                API.request({
                    object: 'WordExclude',
                    method: 'Save',
                    data: params,
                    success: function success(response) {
                        _this.modalHide();
                        self.tags.catalog.reload();
                    }
                });
            }
        }
    });
};
});


// WEBPACK FOOTER //
// ./pages/settings/seo-vars/seo-vars-word-exclude.tag